import React, { Component } from 'react'
import axios from './axios'
import Translate from '../components/translate/conf'
import ReactDOMServer from 'react-dom/server';
import 'datatables.net-buttons-bs4/js/buttons.bootstrap4.min.js'
import 'datatables.net-responsive-bs4/js/responsive.bootstrap4.min.js'
import { Link } from 'react-router-dom';
import ModalLoading from '@app/components/modal-loading/modal-loading';
import { Checkbox } from "@app/components/index";

const $ = require('jquery');
$.DataTable = require('datatables.net');

export default class OnuPonInfoTable extends Component {

  constructor(props) {
    super(props)
    this.state = {
      rows: [],
      mLoading: true
    }
  }

  getFullOnuData = async () => {
    let onuTable = await axios.get('/api/onutable')
    let moduleOnuTable = await axios.get('/api/moduleonutable')
    if (onuTable.data.data !== undefined && moduleOnuTable.data.data !== undefined) {
      onuTable = onuTable.data.data;
      moduleOnuTable.data.data.forEach((v, i, arr) => {
        for (let j = 0; j < onuTable.length; j++) {
          if (v.ucOpticModuleOnuIndex == onuTable[j].id) {
            arr[i] = { ...v, ...onuTable[j] }
            break;
          }
        }
      })
      return moduleOnuTable;
    }
    return { data: [] };
  }

  getTableData = async () => {
    try {
      const res = await this.getFullOnuData()
      this.setState(
        {
          rows: res.data["data"],
          mLoading: false
        },
        () => {
          const newFilterField = this.getFilterField()
          const isCheckedLowPower = this.props.match.params.filter === 'lowPower' 
          $(this.tbl).DataTable({
            "pageLength": 128,
            "lengthMenu": [0, 16, 32, 64, 128, 256, 512],
            "responsive": true,
            "columnDefs": [
              {
                visible: false,
                targets: 0,
              },
              {
                width: '50%',
                targets: 1,
                className: 'th-bg-blue td-blue td-tiny'
              },
              {
                targets: [2, 3, 4, 5, 6, 7, 8],
                className: 'dt-center th-bg-blue td-blue td-tiny'
              },
            ],
            initComplete: function () {
              $('div.dataTables_filter').html(ReactDOMServer.renderToString(newFilterField));
              const obj = this;
              obj.api()
                .columns()
                .every(function () {
                  var that = this;
                  $('input', this.footer()).on('keyup change clear', function () {
                    if (that.search() !== this.value) {
                      that.search(this.value).draw();
                    }
                  });
                });
              $('#filterLowPower').on('click',function(e){
                const search = $(this).is(':checked') ? '-(2[7-9]|[3-9][0-9]).[./ 0-9]+' : ''
                obj.api().column(7).search(search,true,false).draw()
              })
              if( isCheckedLowPower ){
                $('#filterLowPower').trigger('click');
              }
              $('#search').on('keyup change clear',function () {
                obj.api().search(this.value).draw();
              });
            },
          });
        }
      )
    } catch (e) {
      console.log(e)
    }
  }

  getFilterField = () => {
    return (
      <>
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'end' }}>
          <div className="icheck-primary" style={{ marginTop: '4px !important' }}>
            <input type="checkbox" id="filterLowPower" />
            <label htmlFor='filterLowPower'><Translate transVar='ONU.PONInfo.FilterLowPower' /></label>
          </div>
          <div className='verticalSplit' />
          <div>
            <label htmlFor='search'>Search: </label>
            <input type="search" id="search" className="form-control form-control-sm" placeholder="" aria-controls="DataTables_Table_0" />
          </div>
        </div>
      </>
    )
  }

  componentDidMount() {
    this.getTableData();
  }

  tHeader = () => {
    return (
      <>
        <thead>
          <tr>
            <th></th>
            <th><Translate transVar='ONU.Name' /></th>
            <th><Translate transVar='ONU.MACAddress' /></th>
            <th><Translate transVar='ONU.Slot' /></th>
            <th><Translate transVar='ONU.PON' /></th>
            <th><Translate transVar='ONU.PONInfo.Temperature' /><p style={{ margin: 0 }}>ºC</p></th>
            <th><Translate transVar='ONU.PONInfo.TXBias' /><p style={{ margin: 0 }}>mA</p></th>
            <th><Translate transVar='ONU.PONInfo.RXTXPower' /><p style={{ margin: 0 }}>dBm</p></th>
            <th><Translate transVar='ONU.PONInfo.VCC' /></th>
          </tr>
        </thead>
      </>
    );
  }

  tFooter = () => {
    return (
      <>
        <tfoot>
          <tr>
            <td></td>
            <td><input type="text" className="input-footer" placeholder={ReactDOMServer.renderToString(<Translate transVar='ONU.Name' />)} /></td>
            <td><input type="text" className="input-footer" placeholder={ReactDOMServer.renderToString(<Translate transVar='ONU.MACAddress' />)} /></td>
            <td><input type="text" className="input-footer" placeholder={ReactDOMServer.renderToString(<Translate transVar='ONU.Slot' />)} /></td>
            <td><input type="text" className="input-footer" placeholder={ReactDOMServer.renderToString(<Translate transVar='ONU.PON' />)} /></td>
            <td><input type="text" className="input-footer" placeholder={ReactDOMServer.renderToString(<Translate transVar='ONU.PONInfo.Temperature' />)} /></td>
            <td><input type="text" className="input-footer" placeholder={ReactDOMServer.renderToString(<Translate transVar='ONU.PONInfo.TXBias' />)} /></td>
            <td><input type="text" className="input-footer" placeholder={ReactDOMServer.renderToString(<Translate transVar='ONU.PONInfo.RXTXPower' />)} /></td>
            <td><input type="text" className="input-footer" placeholder={ReactDOMServer.renderToString(<Translate transVar='ONU.PONInfo.VCC' />)} /></td>
          </tr>
        </tfoot>
      </>
    );
  }

  tBody = () => {
    let arrTd = []
    this.state.rows.forEach((e, i) => {
      arrTd.push(
        <tr key={i}>
          <td>{e.id}</td>
          <td>{e.ucCfgONUName}</td>
          <td>{e.ucCfgONUPhysicalID}</td>
          <td>{e.ucOpticModuleOnuSlotIndex}</td>
          <td>{e.ucOpticModuleOnuPonIndex}</td>
          <td>{e.ucOpticModuleOnuTemperature}</td>
          <td>{e.ucOpticModuleOnuTxBias}</td>
          <td>{e.ucOpticModuleOnuTxPower} / {e.ucOpticModuleOnuRxPower}</td>
          <td>{e.ucOpticModuleOnuVcc}</td>
        </tr>
      )
    });
    return (
      <>
        <tbody>{arrTd}</tbody>
      </>
    )
  }

  render() {
    return (
      <>
        <ModalLoading show={this.state.mLoading} />
        {!this.state.mLoading &&
          <table width="100%" ref={(tbl) => (this.tbl = tbl)} className='table table-striped'>
            <this.tHeader />
            <this.tBody />
            <this.tFooter />
          </table>
        }
      </>
    )
  }
}